import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import MUIDataTable from 'mui-datatables';
import FormControl from '@mui/material/FormControl';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import CustomSelect from "../CustomComponents/CustomSelect";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from '@mui/material/Checkbox';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid';
import MomentUtils from "@date-io/moment";
import moment from "moment";
import { TextareaAutosize } from "@material-ui/core";
import TextField from "@mui/material/TextField";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
/*import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';*/
/*import MonthPicker from "../../TimesheetItems/MonthPicker";*/
import { DatePicker } from "@material-ui/pickers";
//import { DateValidationError } from '@mui/x-date-pickers/models';
import { MuiThemeProvider } from '@material-ui/core/styles'
import { muiThemeDesign } from '../../mui-theme-design';
import { muiThemePicker } from '../../mui-theme-design';
import {logger, checkAuthentication} from '../../utils';
import { makeStyles } from "@mui/styles";

import { Box, Container } from '@mui/material';

const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiPaper-root": {
            overflowy: "hidden",
            color: '#ffffff'
        },
        "& .Mui-checked": {
            color: '#ffffff'
        },
        "& .MuiCheckBox-root": {
            color: '#ffffff!important',
            fill: '#ffffff'
        },
        "& .MuiSvgIcon-root": {
            color: '#ffffff',
            fill: '#ffffff',
        },
        "& .MuiSvgIcon-error": {
            color: '#c40018',
            fill: '#c40018',
        },
        "& .MuiButton-root": {
            fontSize: "0.7rem"
        },
//.datatables-noprint
    },

}));

export default function UserLogActivity () {
    const [refresh, setRefresh] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [openLogs, setOpenLogs] = React.useState(false);
    const [date, setDate] = React.useState(new Date());
    const [ActivityChoices, setActivityChoices] = React.useState([]);
    const [minDate, setMinDate] = React.useState(new Date());
    const [maxDate, setMaxDate] = React.useState(new Date());
    const [logs, setLogs] = React.useState([]);
     const [dataSet, setDataSet] = React.useState([]);
    const [expand, setExpand] = React.useState(false);

    const classes = pageStyles();

    const initialValues = {
        ActivityID: ''
    };

    const validFormSchema = Yup.object({
        ActivityID: Yup
            .string('Select a Date')
            .required('Date selection Required'),
            
    })

    React.useEffect(() => {
		checkAuthentication();
    //	logger("In UseEffect")
        if (refresh) {
			fetch('/api/activity_logs_dates/', {
		        method: 'GET',
		    })
		    .then(res => res.json())
		    .then(json => {
				//setEnabledDates(json);
		        logger(json);
		        setMinDate(json[0].Date);
		        setMaxDate(json[json.length].Date);
		        logger(minDate);
		        logger(maxDate);
		    })
		    .catch(error => {
		        console.error('Error fetching data:', error);
		    });
		    
		    setRefresh(false);
        }
    })
  
 const handleGenerate = () => {
    fetch('/api/activity_logs/' + new Date(date), {
        method: 'GET',
    })
    .then(res => res.json())
    .then(json => {
        setActivityChoices(json);
        logger(json); 
        const message = json[0].Message;
        logger(message);
        const byteArray = new Uint8Array(message.data);
        const textDecoder = new TextDecoder();
        const res = textDecoder.decode(byteArray);
        logger("Json response", res);
        try {
            json = JSON.parse(res);
            for(var i=0;i<json.length;i++){
				json[i].Action = JSON.stringify(json[i].Action);
			}

            parseJSONResponse(json);
            setOpenLogs(true);
        } catch (error) {
            console.error('Error processing JSON:', error);
        }})
    .catch(error => {
        console.error('Error fetching data:', error);
    });
    
    setRefresh(false);
};

const parseJSONResponse = (response) => {
    setDataSet(response);
}



     const handleClickOpen = () => {
        setRefresh(true)
        setOpen(true)
    };   
    const handleMonth = (childData) => {
        setDate(childData);
        logger ("date loaded -" +  date )
        setRefresh(false)
      }
    const handleClose = () => {
     //   setPOChoices(0);
        setOpen(false);
    };
    
    const handleOpenForLogs = () => {
        setOpenLogs(true)
    };
    
    const handleCloseForLogs = () => {
     //   setPOChoices(0);
        setOpenLogs(false);
    }; 
    
    const disableDates = (date) => {
     return date<minDate || date>maxDate;
    }; 

    const columns = [
        {
            name: "Date",
            label: "Date Time",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "User",
            label: "User",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "Action",
            label: "Action",
            options: {
                filter: true,
                sort: true,
            }
        }
    ];

    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        fixedHeader: true,
        fixedSelectColumn: false,
        tableBodyHeight: "400px",
        tableBodyMaxHeight: "1000px",
        rowsPerPage: 100,
        responsive: 'standard',
        rowsPerPageOptions: [10, 20, 50, 100],
        selectableRows: 'none',

    };
 
    return (
        <div>
        <MuiThemeProvider theme={muiThemeDesign}>
            <Button variant="contained" onClick={handleClickOpen}>
                User Log Activity
            </Button>
             <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">                
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                           edge="start"
                                           color="inherit"
                                           onClick={handleClose}
                                           aria-label="close"
                                        >
                                          <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            Log Activity
                                        </Typography>
                                       <Button autoFocus color="inherit" onClick={handleGenerate}>
                                            Generate
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                <DialogTitle>User Activity Log Report:</DialogTitle>  
								     	<div sx={{paddingTop: {xs:10, sm:10, md: 10, lg:0, xl: 0}}} > 
									       <MuiPickersUtilsProvider utils={MomentUtils} locale="en">
                                            <div>
                                              
									         <DatePicker
                                            
                                                   label="Month and Date"
                                                   views={['month', 'date']}
                                                    value={date}
                                                    openTo="date" 
                                                closeOnSelect={true}
                                                onChange={handleMonth}
                                                minDate={minDate}
                                                maxDate={maxDate}
                                                shouldDisableDate={disableDates}
                                             //       onError={(newError) => setError(newError)}
                                              //  renderInput={(params) => <TextField {...params} helperText={null} />}
                                                    />
                                                  
									         </div>
									       </MuiPickersUtilsProvider>
									    </div>
								    	<div>
									        <div className={classes.root}>
									            <MuiThemeProvider theme={muiThemeDesign} onClick={handleOpenForLogs}>
									                <Dialog className={classes.root} open={openLogs} onClose={handleCloseForLogs} fullWidth maxWidth="1400px" scroll="paper" overflow-y="hidden">
									                    <DialogContent >
									                        <Box>
									
									                            <MUIDataTable className={classes.root}
									                                title={
									
									                                    <Typography variant="h6" style={{ color: "white" }}>
									                                        <IconButton edge="start" color="inherit" onClick={handleCloseForLogs} aria-label="close"> <CloseIcon /> </IconButton>
									                                        User Activity Logs &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; DateTime In UTC: {new Date().toUTCString()}
									                                    </Typography>
									                                }
									                                data={dataSet}
									                                columns={columns}
									                                options={options}
									                            />
									                        </Box>
									                    </DialogContent>
									                </Dialog>
									            </MuiThemeProvider>
									        </div>
								    	</div>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>                
            </Dialog>
            </MuiThemeProvider>
        </div>
    );
}
 